var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"},attrs:{"id":"mask"},on:{"click":function($event){return _vm.$store.commit('book/showBookVideo')}}},[_c('div',{staticClass:"video",on:{"click":function($event){$event.stopPropagation();}}},[_c('video',{attrs:{"src":_vm.bookVideoItem.short_video_url,"controls":"","height":"100%","autoplay":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }